<template>
  <div class="section-container bg-white">
    <LottieObject class="col-12 col-lg-5 home-left-lottie" jsonFile="home-left-intro.json" :loop="false"></LottieObject>
    <LottieObject class="col-12 col-lg-5 home-right-lottie" jsonFile="home-right-intro_1.json" :loop="false"></LottieObject>
    <div class="home-banner px-0 px-lg-5">
      <div class="container py-4 px-5 px-lg-0" style="max-width: 1200px;">
        <div class="row py-sm-3 py-md-5">
          <LottieObject class="col-12 col-md-7 pt-2 pt-md-5" jsonFile="home-hello.json" :loop="false"></LottieObject>
          <img class="col-5 d-none d-lg-block wow animate__fadeIn" data-wow-delay="0.5s" data-wow-duration="1s" src="@/assets/home/home-hello-line.svg" alt="Hello!" style="height: 300px; margin-left: -12%;" />
        </div>
        <div class="row py-sm-3 py-md-5">
          <h1 class="col-12 col-lg-6 pt-4 pt-lg-1 wow animate__fadeInUp" data-wow-delay="0.5s">We are Nologo Studios.<br>Your Technology Partners.</h1><br class="d-block d-md-none"><br class="d-block d-md-none">
          <img class="col-12 col-lg-5 pt-4 pt-lg-1 wow animate__fadeInUp" data-wow-delay="1s" src="@/assets/home/home-microsoft-icons-02.png" alt="Certified as Microsoft Gold Partner and Google Partner" style="max-width: fit-content; height: 10%;" />
        </div>
        <div class="row pt-5">
          <p class="wow animate__fadeIn" data-wow-delay="1s"><span class="slogan-text text-primary">nothing. </span><br class="d-block d-lg-none fw-500 lh-1"> don't believe in digital for the sake of digital.</p>
          <p class="wow animate__fadeIn" data-wow-delay="1.25s"><span class="slogan-text text-secondary">but. </span><br class="d-block d-lg-none fw-500"> developing and implementing clear strategies for how digital can grow your business.</p>
          <p class="wow animate__fadeIn" data-wow-delay="1.5s"><span class="slogan-text text-tertiary">excellence. </span><br class="d-block d-lg-none fw-500"> brilliant custom digital solutions.</p>
        </div>
        <br>
        <router-link to="#AboutUs" class="" style="width: 220px; display: contents;">
          <LottieObject class="col-12 col-lg-5 py-0 py-lg-5" jsonFile="home-arrow.json" style="width: 220px; margin-left: auto; margin-right: auto; display: block;"></LottieObject>
        </router-link>
      </div>
    </div>

    <div id="AboutUs" class="about-us">
      <div class="container py-1 pb-md-5">
        <div class="row py-lg-5">
          <div class="col-12 col-lg-6 py-4 py-lg-5 px-5 wow animate__fadeIn" data-wow-delay="0.5s">
            <ContentBlock alias="home-about-us" :subtitleFirst="true" />
          </div>
          <div class="col-12 col-lg-6 category-images wow animate__fadeIn" data-wow-delay="0.75s">
            <LottieObject class="home-aboutus-animation d-none d-lg-block" jsonFile="about-us.json">
              <img class="img1" src="@/assets/home/home-about-us-bg.svg" alt="" style="top: 0" />
              <img class="img2" src="@/assets/home/home-about-us-dots.svg" alt="" style="top: 0" />
              <img class="img3" src="@/assets/home/about-us-image.jpg" alt="" />
            </LottieObject>
            <div class="d-lg-none overflow-hidden">
              <img class="img-fluid img3" src="@/assets/home/about-us-image.jpg" alt="" />
              <!-- <hr class="m-0"> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-container case-studies pb-5" v-if="caseStudyThumbnail && caseStudyThumbnail.length > 0">
      <div class="case-studies-text">
        <h2 class="text-white text-center">
          <small class="text-uppercase d-block">Nologo Studios</small>
          Case Studies
        </h2>
      </div>

      <div id="CaseStudies">
        <div class="carousel-navigation d-flex justify-content-center mb-4">
          <button @click="caseStudyPrev()" class="carousel-control-prev position-relative" type="button">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button @click="caseStudyNext()" class="carousel-control-next position-relative" type="button">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
        <carousel ref="CaseStudies" :breakpoints="breakpointCaseStudy" :autoplay="5000" :wrap-around="true">
          <slide v-for="(caseStudy, index) in caseStudyThumbnail" :key="caseStudy">
            <div class="card overflow-hidden wow animate__fadeIn" :data-wow-delay="`0.${5+index}s`">
              <img :src="CmsBaseUrl() + caseStudy.logoThumbnail.urls[0]" />
              <div class="shadow card-body">
                <router-link class="btn btn-outline-dark text-uppercase rounded-0 py-2 px-4 px-sm-5" :to="{ name: 'case-study', params: { alias: getClientSlug(caseStudy.alias.alias) } }">
                  View Case Study
                </router-link>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </div>

    <div id="Development" class="development">
      <div class="container py-1 pb-md-5">
        <div class="row py-lg-5">
          <div class="col-12 col-lg-6 py-4 py-lg-5 px-5 order-lg-1 wow animate__fadeIn" data-wow-delay="0.5s">
            <ContentBlock alias="home-development" :subtitleFirst="true" />
          </div>
          <div class="col-12 col-lg-6 category-images order-lg-0 wow animate__fadeIn" data-wow-delay="0.75s">
            <LottieObject class="home-development-animation d-none d-lg-block" jsonFile="development.json">
              <img class="img1" src="@/assets/home/home-development-bg.svg" alt="" style="top: 0; left: 20% !important;" />
              <img class="img2" src="@/assets/home/home-development-dots.svg" alt="" style="top: -51%; right: 34% !important;" />
              <img class="img3" src="@/assets/home/development-image.jpg" alt="" />
            </LottieObject>
            <div class="d-lg-none overflow-hidden">
              <img class="img-fluid img3" src="@/assets/home/development-image.jpg" alt="" />
              <hr class="m-0">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="Hosting" class="hosting">
      <div class="container py-1 pb-md-5">
        <div class="row py-lg-5">
          <div class="col-12 col-lg-6 py-4 py-lg-5 px-5 wow animate__fadeIn" data-wow-delay="0.5s">
            <ContentBlock alias="home-hosting" :subtitleFirst="true" />
          </div>
          <div class="col-12 col-lg-6 category-images wow animate__fadeIn" data-wow-delay="0.75s">
            <LottieObject class="home-hosting-animation d-none d-lg-block" jsonFile="hosting.json">
              <img class="img5" src="@/assets/home/home-hosting-img-2.png" alt="" />
              <img class="img2" src="@/assets/home/home-hosting-bg.svg" alt="" style="top: 0; width: 60% !important;" />
              <img class="img2" src="@/assets/home/home-development-dots.svg" alt="" style="top: 0; right: 10% !important;" />
              <img class="img4" src="@/assets/home/hosting-image.jpg" alt="" />
            </LottieObject>
            <div class="d-lg-none overflow-hidden">
              <img class="img-fluid img4" src="@/assets/home/hosting-image.jpg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container text-center">
      <hr class="mt-3 my-5" />
      <h2>
        <small class="d-block">These are</small>
        Our Clients
      </h2>

      <div class="row my-5">
        <template v-for="(client, index) in clientList">
          <div class="col-12 col-sm-6 col-lg-3 wow animate__fadeIn" :data-wow-delay="`0.${5+index}s`">
            <a :href="client.siteLink" target="_blank">
              <div class="client-item">
                <img class="img-fluid px-2" :src="CmsBaseUrl() + client.logo.urls[0]" :alt="client.displayText + ' logo'">
              </div>
            </a>
          </div>
        </template>
      </div>

      <router-link class="btn btn-outline-dark text-uppercase rounded-0 py-2 px-4 px-sm-5" to="/clients">Read More</router-link>
      <hr class="my-5" />
    </div>
  </div>

  <div class="section-container bg-white wow animate__fadeIn" data-wow-delay="1s" v-if="clientQuotes && clientQuotes.additionalContent.contentItems.length > 0">
    <div class="testimonials py-5">
      <div class="container-fluid container-lg text-center py-3">
        <h2 class="h3 mb-4">{{ clientQuotes.contentBlockTitle }}</h2>
        <img src="@/assets/home/testimony-icon.png" alt="" style="width: 30px; margin-left: auto; margin-right: auto; display: table;">

        <carousel :items-to-show="1" :autoplay="10000" :wrap-around="true">
          <slide v-for="quotes in clientQuotes.additionalContent.contentItems" :key="quotes">
            <div class="row justify-content-center">
              <div class="col-lg-9">
                <div class="text-muted pb-3 pt-4 px-5" v-html="quotes.markdownBody.html"></div>
                <b class="h5 d-block mb-3">{{ quotes.displayText }}</b>
                <p><i>{{ quotes.contentBlockSubtitle }}</i></p>
              </div>
            </div>
          </slide>

          <template #addons>
            <navigation />
          </template>
        </carousel>
      </div>
    </div>
  </div>

  <div class="section-container subsidiaries">
    <div class="container text-center py-1 pb-md-5">
      <hr class="my-5" />
      <h2>
        <small class="text-uppercase d-block">Nologo Studios</small>
        Subsidiaries
      </h2>
      <div class="py-5">
        <carousel id="Subsidiaries" :breakpoints="breakpointSubsidiary" :autoplay="10000" :wrap-around="true">
          <slide v-for="(subsidiary, index) in subsidiaries" :key="subsidiary">
            <div class="card w-100 overflow-hidden shadow wow animate__fadeInUp" :data-wow-delay="`0.${5+index}s`">
              <div class="card-body pt-4">
                <img :src="CmsBaseUrl() + subsidiary.cardLogo.urls[0]" :alt="subsidiary.displayText + ' logo'" />
                <div class="text-muted text-start pb-3 pt-4 px-3" v-html="subsidiary.blurb.html"></div>
                <div class="text-start px-3 pb-2 pb-md-5 pb-lg-0">
                  <router-link class="btn btn-outline-dark text-uppercase rounded-0 py-2 px-4 px-sm-5" :to="{ name: 'subsidiary', params: { alias: getSubsidiarySlug(subsidiary.alias.alias) } }" >
                    View {{ subsidiary.displayText }}
                  </router-link>
                </div>
              </div>
              <img :src="CmsBaseUrl() + subsidiary.cardImage.urls[0]" class="w-100" style="margin-top: -60px; pointer-events: none;" alt="" />
            </div>
          </slide>
        </carousel>
      </div>
      <hr class="my-5" />
    </div>
  </div>

  <div class="section-container bg-white">
    <div class="row" id="ContactUs">
      <div class="col-lg-6 order-lg-1 px-5 pb-5 pt-sm-5">
        <ContactForm></ContactForm>
      </div>
      <div class="col-lg-6 order-lg-0 lh-1">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13844.626601511483!2d30.9518452!3d-29.8308998!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ef700efd1e6aeff%3A0xa3e544220bd5304b!2sNologo%20Studios!5e0!3m2!1sen!2sza!4v1691150863115!5m2!1sen!2sza" width="100%" height="700" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, Ref, onMounted } from "vue"
  import LottieObject from "@/components/general/LottieObject.vue"
  import ContentBlock from "@/components/general/ContentBlock.vue"
  import ContactForm from "@/components/general/ContactForm.vue"
  import { CmsBaseUrl, scrollTop } from "@/utils/functions"
  import { getClientLogos, getClientQuotes, getClientSlug, getSubsidiarySlug, getCaseStudyThumbnail, getSubsidiaries } from "@/utils/graphql"
  import { useApolloClient } from '@vue/apollo-composable'
  import 'vue3-carousel/dist/carousel.css'
  import { Carousel, Slide, Navigation } from 'vue3-carousel'
  import router from "@/router"
  import 'animate.css'
  import 'wow.js'
  import 'wowjs'

  var clientList: Ref<any | undefined> = ref(undefined)
  var clientQuotes: Ref<any | undefined> = ref(undefined)
  var caseStudyThumbnail: Ref<any | undefined> = ref(undefined)
  var subsidiaries: Ref<any | undefined> = ref(undefined)
  var CaseStudies: Ref<any> = ref(null)
  var breakpointCaseStudy: Ref<any | undefined> = ref({
    0: {
      itemsToShow: 1.1
    },
    460: {
      itemsToShow: 1.75
    },
    768: {
      itemsToShow: 2
    },
    992: {
      itemsToShow: 3.5
    },
    1200: {
      itemsToShow: 4
    },
    1400: {
      itemsToShow: 5
    }
  })
  var breakpointSubsidiary: Ref<any | undefined> = ref({
    0: {
      itemsToShow: 1
    },
    768: {
      itemsToShow: 2
    },
    1200: {
      itemsToShow: 3
    }
  })

  function caseStudyPrev() {
    CaseStudies.value.prev()
  }

  function caseStudyNext() {
    CaseStudies.value.next()
  }
  
  onMounted(async () => {
    const { resolveClient } = useApolloClient()
    const ApolloClient = resolveClient()
    
    await getClientLogos(ApolloClient).then(res => {
      clientList.value = res as any
    });
    await getClientQuotes(ApolloClient).then(res => {
      clientQuotes.value = res as any
    });
    await getCaseStudyThumbnail(ApolloClient).then(res => {
      caseStudyThumbnail.value = res as any
    });
    await getSubsidiaries(ApolloClient).then(res => {
      subsidiaries.value = res as any
    });

    setTimeout(() => {
      if (router.currentRoute.value.hash.includes("ContactUs")) {
        scrollTop("#ContactUs")
      }
    }, 200)
  })
</script>

<style scoped lang="scss">
  .home-banner {
    h1 {
      font-weight: 200;
      font-size: 2.5rem;
      color: #a5a5a5;
    }
  }

  .home-left-lottie,
  .home-right-lottie {
    display: block;
    position: absolute;
    width: 650px;
    top: -1%;
    @media (max-width: 1200px){
      top: -16%;
      width: 500px;
    }
    @media (max-width: 768px){
      display: none;
    }
  }
  .home-left-lottie {
    right: 85%;
    @media (max-width: 1200px){
      right: 80%;
    }
  }

  .home-right-lottie {
    left: 80%;
    @media (max-width: 1200px){
      left: 80%;
    }
  }

  .about-us, .development, .hosting {
    :deep {
      @include media-breakpoint-up(md) {
        h2 {
          font-size: 3.4rem;
        }
      }
      @include media-breakpoint-up(lg) {
        h2 {
          font-size: 3.8rem;
        }
        h3 {
          font-size: 2.4rem;
        }
      }
      @include media-breakpoint-up(xl) {
        h2 {
          font-size: 5rem;
        }
        h3 {
          font-size: 3rem;
        }
      }
    }
    .home-aboutus-animation,
    .home-development-animation,
    .home-hosting-animation {
      pointer-events: none;
      position: relative;
      height: 100%;
      :deep .lottie-wrapper {
        position: absolute;
        display: none;
        z-index: 11;
        @media (min-width: 992px){
          display: block;
        }
      }
    }

    .img1, .img2, .img3, .img4, .img5 {
      position: absolute;
      margin: auto;
      bottom: 0;
      z-index: 10;
    }

    .img1 {
      left: 10%;
      width: 80%;
    }

    .img2 {
      left: 0;
      right: 0;
      width: 50%;
    }

    .img3 {
      top: 0;
      left: 0;
      right: 0;
      width: 90%;
      clip-path: polygon(35% 0, 100% 0, 65% 100%, 0 100%);
      pointer-events: none;
    }

    .img4 {
      top: 0;
      left: 0;
      right: 0;
      width: 90%;
      clip-path: polygon(92% 0, 21% 23%, 54% 100%);
      pointer-events: none;
    }
    
    .img5 {
      top: 10%;
      left: 60%;
      right: 0;
      width: 30%;
      z-index: 20;
    }

    @media (max-width: 991px){
      .img1, .img2, .img5 {
        display: none;
      }

      .img3, .img4 {
        width: 100% !important;
        margin-top: -70px !important;
        position: relative !important;
        display: flex;
        clip-path: polygon(0 18%, 100% 18%, 100% 80%, 0 80%) !important;
        pointer-events: none;
      }
    }
  }

  .about-us {
    :deep .home-about-us-content {
      h3 {
        color: $primary;
      }
    }
  }

  .home-aboutus-animation {
    :deep .lottie-wrapper {
      width: 800px;
      top: -6%;
      bottom: -10%;
      left: -18%;
      @media (min-width: 1200px){
        width: 170%;
        top: -25%;
        bottom: -10%;
        left: -12%;
      }
      @media (min-width: 1400px){
        top: -40%;
        bottom: -40%;
        left: -15%;
      }
    }
  }

  .development {
    :deep .home-development-content {
      h3 {
        color: $secondary;
      }
    }
  }

  .home-development-animation {
    :deep .lottie-wrapper {
      width: 110px;
      left: -9%;
      @media (min-width: 768px){
        width: 700px;
        top: -8%;
        bottom: -28%;
        left: -17%;
      }
      @media (min-width: 1200px){
        width: 900px;
        top: 2%;
        bottom: -25%;
        left: -24%;
      }
      @media (min-width: 1400px){
        bottom: -28%;
        left: -11%;
      }
    }
  }

  .development {
    .category-images {
      @media (min-width: 992px){
        position: relative;
        top: 0;
        right: 8%;
      }
      @media (min-width: 1200px){
        right: 15%;
      }
    }
  }

  .hosting {
    :deep .home-hosting-content {
      h3 {
        color: $tertiary;
      }
    }
  }
  
  .home-hosting-animation {
    :deep .lottie-wrapper {
      width: 400px;
      top: 4%;
      bottom: 4%;
      left: 8%;
      @media (min-width: 1200px){
        width: 90%;
        top: -3%;
        bottom: -3%;
        left: 5%;
      }
      @media (min-width: 1400px){
        top: -18%;
        bottom: -18%;
        left: 6%;
      }
    }
  }

  .client-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 180px;
    @media (min-width: 576px) {
      min-height: 0;
    }
    img {
      width: 200px;
      display: flex;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .testimonials{
    background-image: url('@/assets/home/testimony-bg.png');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: bottom;

    p, :deep p {
      opacity: .75;
    }
    
    :deep .carousel__viewport {
      overflow: visible;
      .carousel__slide > div {
        pointer-events: none;
      }
      .carousel__slide {
        opacity: 0;
        transition: opacity .4s;
      }

      .carousel__slide--active {
        opacity: 1;
        transition: opacity 0s;
      }
    }
  }

  .case-studies {
    background-color: #f8f9fa;
    .case-studies-text {
      display: grid;
      background-image: url('@/assets/home/case-study_bg.jpg');
      background-repeat: no-repeat;
      background-position: center bottom;
      height: 500px;
      align-items: center;
      justify-content: center;
    }
    h2 {
      margin-top: -160px;
    }
    :deep .card {
      border: none !important;
    }
  }

  .case-studies, .subsidiaries {
    h2 {
      small {
        font-size: 20px;
        letter-spacing: 4px;
        opacity: 1;
      }
    }
  }

  #CaseStudies {
    margin-top: calc(500px * -0.5);
    :deep .carousel__slide {
      padding: 0 20px;
    }
  }

  #Subsidiaries {
    :deep {
      .carousel__slide {
        padding: 0 10px;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }
      @media (min-width: 992px) {
        .carousel__slide--sliding {
          transition: 0.3s;
        }
        .carousel__slide {
          opacity: .5;
          transform: scale(0.7);
        }
        .carousel__slide--prev,
        .carousel__slide--next {
          transform: scale(0.82);
        }
        .carousel__slide--active {
          opacity: 1;
          transform: scale(0.95);
        }        
      }

    }
  }
</style>